<template>
  <div class="page-home">
    <div class="banner">
      <img :src="indexInfo.banner" alt="" />
      <div
        class="flex-center rule"
        @click="viewRule"
        :style="{
          color: indexInfo.ruleColor,
          background: indexInfo.ruleBg
        }"
      >
        {{ jsonRules.activityRules }}
      </div>
    </div>
    <div class="video-bg" v-if="currentStatus === 'home' && indexInfo.videoUrl">
      <img class="video-bg-img" :src="indexInfo.videoBgUrl" alt="" />
      <div class="video-box">
        <video
          autoplay
          controls
          style="width:8.533333rem;height:5.146667rem"
          :poster="indexInfo.videoPosterUrl"
          :src="indexInfo.videoUrl"
        />
      </div>
    </div>
    <div class="wrapper">
      <div
        class="entry"
        :style="{ background: indexInfo.couponBg }"
        v-if="currentStatus === 'home'"
      >
        <img :src="indexInfo.couponImg" alt="" />
        <div
          class="flex-center btn"
          @click="handleClick"
          :style="{
            background: indexInfo.theme,
            color: indexInfo.btnColor,
            boxShadow: indexInfo.btnShadow
          }"
        >
          {{ indexInfo.btnCon || jsonRules.clickToGet }}
        </div>
      </div>

      <!-- 新用户 -->
      <div class="entry" :style="{ background: indexInfo.couponBg }" v-if="currentStatus === 'new'">
        <p class="title">
          {{ couponHasSend === 1 ? jsonRules.alreadyReceived : jsonRules.receiveSuccess }}
        </p>
        <div class="img-wrapper">
          <img v-for="(v, i) in newSuccessInfo.couponList" :key="i" :src="v" alt="" />
        </div>
        <div class="flex-center btn-wrapper" v-if="newSuccessInfo && newSuccessInfo.hasBtn">
          <div
            class="flex-center btn"
            @click="goLink(newSuccessInfo.btnLink, newSuccessInfo.btnGo, newSuccessInfo.hasTab)"
            :style="{
              background: indexInfo.theme,
              color: indexInfo.btnColor,
              boxShadow: indexInfo.btnShadow
            }"
          >
            {{ newSuccessInfo.btnCon || jsonRules.immediateUse }}
          </div>
        </div>
      </div>
      <!-- 老用户 -->
      <div class="entry" :style="{ background: indexInfo.couponBg }" v-if="currentStatus === 'old'">
        <p class="title">
          {{ couponHasSend === 1 ? jsonRules.alreadyReceived : jsonRules.receiveSuccess }}
        </p>
        <div class="img-wrapper">
          <img v-for="(v, i) in oldSuccessInfo.couponList" :key="i" :src="v" alt="" />
        </div>
        <div class="flex-center btn-wrapper" v-if="oldSuccessInfo && oldSuccessInfo.hasBtn">
          <div
            class="flex-center btn"
            @click="goLink(oldSuccessInfo.btnLink, oldSuccessInfo.btnGo, oldSuccessInfo.hasTab)"
            :style="{
              background: indexInfo.theme,
              color: indexInfo.btnColor,
              boxShadow: indexInfo.btnShadow
            }"
          >
            {{ oldSuccessInfo.btnCon || jsonRules.immediateUse }}
          </div>
        </div>
      </div>

      <!-- 领取失败 -->
      <div
        class="entry"
        :style="{ background: indexInfo.couponBg }"
        v-if="currentStatus === 'fail'"
      >
        <p class="title">{{ jsonRules.receiveFailed }}</p>
        <p class="sub-title">{{ jsonRules.sorryEmpty }}</p>
        <img class="fail-img" :src="failInfo && failInfo.failImg" alt="" />
        <!-- 这里golink默认给1是因为之前领券失败缺少跳转微信小程序/h5的按钮，因此老数据都缺少btnGo,此次默认给个微信小程序跳转 -->
        <div
          v-if="failInfo && failInfo.hasBtn"
          class="flex-center btn"
          @click="goLink(failInfo.btnLink, failInfo.btnGo || '1')"
          :style="{
            background: indexInfo.theme,
            color: indexInfo.btnColor,
            boxShadow: indexInfo.btnShadow
          }"
        >
          {{ failInfo.btnCon || jsonRules.continueToOrder }}
        </div>
      </div>

      <img
        v-for="(v, i) in [...otherList, ...indexInfo.footList]"
        :key="i"
        class="desc-img"
        :src="v"
        alt=""
      />
    </div>
    <login />
    <rule />

    <div
      class="flex-center bottom"
      v-if="newSuccessInfo && newSuccessInfo.hasBtn && showBottom && currentStatus === 'new'"
    >
      <div
        class="flex-center btn"
        @click="goLink(newSuccessInfo.btnLink, newSuccessInfo.btnGo, newSuccessInfo.hasTab)"
        :style="{
          background: indexInfo.theme,
          color: indexInfo.btnColor,
          boxShadow: indexInfo.btnShadow
        }"
      >
        {{ newSuccessInfo.btnCon || jsonRules.immediateUse }}
      </div>
      <img :src="up" alt="" @click="goTop" />
    </div>

    <div
      class="flex-center bottom"
      v-if="oldSuccessInfo && oldSuccessInfo.hasBtn && showBottom && currentStatus === 'old'"
    >
      <div
        class="flex-center btn"
        @click="goLink(oldSuccessInfo.btnLink, oldSuccessInfo.btnGo, oldSuccessInfo.hasTab)"
        :style="{
          background: indexInfo.theme,
          color: indexInfo.btnColor,
          boxShadow: indexInfo.btnShadow
        }"
      >
        {{ oldSuccessInfo.btnCon || jsonRules.immediateUse }}
      </div>
      <img :src="up" alt="" @click="goTop" />
    </div>

    <div
      class="flex-center bottom"
      v-if="failInfo && failInfo.hasBtn && showBottom && currentStatus === 'fail'"
    >
      <!-- 这里golink默认给1是因为之前领券失败缺少跳转微信小程序/h5的按钮，因此老数据都缺少btnGo,此次默认给个微信小程序跳转 -->
      <div
        class="flex-center btn"
        @click="goLink(failInfo.btnLink, failInfo.btnGo || '1')"
        :style="{
          background: indexInfo.theme,
          color: indexInfo.btnColor,
          boxShadow: indexInfo.btnShadow
        }"
      >
        {{ failInfo.btnCon || jsonRules.continueToOrder }}
      </div>
      <img :src="up" alt="" @click="goTop" />
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { init } from '@api/userchannel';
import Login from '../components/Login';
import Rule from '../components/Rule';
import http from '@utils/request';
import { getUserInfo } from '@/utils/authCode';
import { shortUrl, trackData } from '../api';
import { url2json } from '@utils';
import { TrackType } from '@utils/track';
import { getUrlString } from 'better-js-lib';
import { LOCAL_STORAGE_TRACK } from '@utils';
import { zh_CN, zh_HK, en } from '../language';
// import { appUser } from 'syttunnel';
let appUser;
let appNavigator;
if (typeof window !== 'undefined') {
  let syttunnel = require('syttunnel');
  appUser = syttunnel.appUser;
  appNavigator = syttunnel.appNavigator;
}

export default {
  asyncData({ store, router, serverConfig }) {
    // serverConfig 服务端传来的参数，本次是为了区分线上 测试环境，历史的h5是没有这个参数的
    const isRonghe = serverConfig && serverConfig.env === 'ronghe';
    if (router.history.current.query.file_name) {
      return new Promise((resolve, reject) => {
        console.log('请求开始');
        // todo 修改
        const url = isRonghe
          ? `http://${serverConfig.ip}:${serverConfig.port}/growth/theme/getfileinfo`
          : `https://markettc.sf-express.com/growth/theme/getfileinfo`;
        // const onlineUrl = 'https://markettc.sf-express.com/growth/theme/getfileinfo';
        // const mirrorUrl = 'http://10.210.64.7:8087/growth/theme/getfileinfo';
        // const devUrl = 'http://10.210.40.112:8087/growth/theme/getfileinfo';
        console.log(url, 'url', router.history.current.query);
        http
          .post(url, {
            ...router.history.current.query
          })
          .then(
            res => {
              console.log('请求结束');
              store.dispatch('render', JSON.parse(res));
              resolve();
            },
            err => {
              console.log(err);
              reject();
            }
          );
      });
    } else {
      return Promise.resolve();
    }
  },
  components: {
    Login,
    Rule
  },
  data() {
    return {
      showBottom: false,
      up: require('../images/up.png')
    };
  },
  computed: {
    ...mapState({
      city_name: state => state.city_name,
      currentStatus: state => state.currentStatus,
      couponHasSend: state => state.couponHasSend,
      loginFlag: state => state.loginFlag,
      ruleFlag: state => state.ruleFlag,
      urlQuery: state => state.urlQuery,
      advInfo: state => state.advInfo,

      baseInfo: state => state.baseInfo,
      indexInfo: state => state.indexInfo,
      newSuccessInfo: state => state.newSuccessInfo,
      oldSuccessInfo: state => state.oldSuccessInfo,
      failInfo: state => state.failInfo,
      platform: state => state.platform,
      env: state => state.env,
      jsonRules: state => state.jsonRules
    }),

    otherList() {
      if (this.currentStatus === 'new') {
        return this.newSuccessInfo.otherList;
      } else if (this.currentStatus === 'old') {
        return this.oldSuccessInfo.otherList;
      } else if (this.currentStatus === 'fail') {
        return this.failInfo.otherList;
      } else {
        return [];
      }
    }
  },

  mounted() {
    window.sfjsPoint.track('user_channel_load', {
      type: this.urlQuery.s
    });
    console.log(process.env.npm_config_testip, 'testip');
    document.title = this.baseInfo.title;
    this.currentLanguage(window.navigator.language);
    document.addEventListener('scroll', () => {
      const scrollTop = document.documentElement.scrollTop;
      const currentTop = document.querySelector('.entry').offsetTop;
      const currentHeight = document.querySelector('.entry').clientHeight;
      this.showBottom = scrollTop > currentTop + currentHeight;
    });
  },
  watch: {
    currentStatus(val) {
      if (val === 'new' || val === 'old' || val === 'fail') {
        // 埋点
        window.sfjsPoint.track('enter_result_page'); // 到结果页
      }
    }
  },
  methods: {
    ...mapActions(['wechatGwechatGetLocation']),
    ...mapMutations(['setState']),
    goTop() {
      document.documentElement.scrollTop = 0;
    },
    currentLanguage(language) {
      switch (language) {
        case 'zh-CN':
          this.setState({
            jsonRules: zh_CN,
            lang: 'zh-CN'
          });
          break;
        case 'zh-TW':
          this.setState({
            jsonRules: zh_HK,
            lang: 'zh_HK'
          });
          break;
        case 'zh-HK':
          this.setState({
            jsonRules: zh_HK,
            lang: 'zh_HK'
          });
          break;
        case 'en-US':
          this.setState({
            jsonRules: en,
            lang: 'en'
          });
          break;
      }
    },

    goLink(link, btnGo, hasTab) {
      console.log(hasTab, 'hasTab');
      // 埋点
      window.sfjsPoint.track('click_immediately_order'); // 点击立即下单
      if (btnGo) {
        switch (btnGo) {
          case '1': // 微信小程序
            if (this.env === '微信小程序') {
              if (hasTab) {
                console.log(hasTab, '普通页');
                // eslint-disable-next-line no-undef
                wx.miniProgram.navigateTo({
                  url: link
                });
              } else {
                console.log(hasTab, 'tab页');
                // 历史页面默认是tab页面    首页路径：/pages/home/index
                // eslint-disable-next-line no-undef
                wx.miniProgram.switchTab({
                  url: link
                });
              }
            } else {
              // http/https开头的直接跳转
              const regx = /^http(s)?:\/\//;
              if (regx.test(link)) {
                location.href = link;
              } else {
                // 生成短链， 然后再跳转
                const temp = url2json(link);
                shortUrl({
                  path: link.split('?')[0],
                  expire_time: this.$moment()
                    .add(1, 'h')
                    .unix(),
                  query: getUrlString({
                    platform: this.platform,
                    ...this.urlQuery,
                    ...temp,
                    advChannel: this.advInfo.channel,
                    advClickId: this.advInfo.clickId
                  })
                }).then(res => {
                  if (res) {
                    location.href = res.short_url;
                  }
                });
              }
            }
            return;
          case '2': // h5
            if (link.indexOf('?') === -1) {
              location.href = `${link}?platform=${this.platform}`;
            } else {
              const temp = url2json(link);
              const p = Object.prototype.hasOwnProperty.call(temp, 'platform')
                ? temp
                : {
                    ...temp,
                    platform: this.platform
                  };
              location.href = `${link}${getUrlString(p, { hasPrefix: true })}`;
            }
            return;
          case '3': // 速运app
            appNavigator.navigate(link);
            return;
          default:
            location.href = link;
            break;
        }
      } else {
        location.href = link;
      }
    },

    async getCoupon() {
      let type = null;
      let code = null;
      if (this.urlQuery.openId) {
        type = 2;
      } else if (this.urlQuery.c_token) {
        // bannner
        type = 3;
      } else if (this.urlQuery.token || this.urlQuery.authCode) {
        // 广告投放配置扫码进入
        // authCode是兼容c端传参数，从stoken改为了authCode
        type = 4;
        if (this.urlQuery.authCode) {
          await getUserInfo();
        }
      } else if (
        Array.isArray(window.navigator.userAgent.match(/SFEXPRESSAPP/i)) &&
        window.navigator.userAgent.match(/SFEXPRESSAPP/i).length > 0
      ) {
        // 速运广告位免登录同城领券H5(app免登录)
        type = 1;
        await appUser
          .authorize({ appid: '202302021409425495', scope: 'sf_base,sf_mobile' })
          .then(res => {
            if (res && +res.errorCode === 0) {
              code = res.code;
            }
          });
      }

      let params = {
        ...this.urlQuery,
        inviter_token: this.urlQuery.s,
        type,
        city_name: this.city_name,
        code // 临时授权凭证 code（有效期 5 分钟）
      };
      // 路由没有STOKEN了,而且种token不用这种方式
      // if (!this.urlQuery.token && this.urlQuery.stoken) {
      //   params.token = this.urlQuery.stoken;
      // }
      if (params.authCode) {
        delete params.authCode;
      }
      init(params)
        .then(
          res => {
            if (res.coupon_list.length) {
              this.setState({
                couponHasSend: res.has_send,
                currentStatus: res.is_new ? 'new' : 'old'
              });
              console.log('byte');
              window.sfjsPoint.track('get_coupon_success', {
                type: this.urlQuery.s
              }); // 领取成功
              const p = {
                type: this.advInfo.channel,
                click_id: this.advInfo.clickId,
                url: location.href,
                action_time: Date.now(),
                user_id: res.user_id,
                action_type: this.advInfo.channel === TrackType.tencent ? 'CLAIM_OFFER' : 'form',
                open_id: localStorage.getItem(LOCAL_STORAGE_TRACK) || '',
                action_param: JSON.stringify({
                  platform: this.platform
                })
              };
              trackData(p).then(res => {
                console.log(res, 'get coupon track');
              });
            } else {
              this.setState({
                currentStatus: 'fail'
              });
            }
          },
          () => {
            document.querySelector('.van-toast').style.display = 'none';
            this.setState({
              loginFlag: true
            });
            this.$nextTick(() => {
              const phoneInput = document.querySelector('.phone-input');
              setTimeout(() => {
                phoneInput.focus();
              }, 300);
            });
          }
        )
        .catch(() => {
          window.sfjsPoint.track('get_coupon_fail', {
            type: this.urlQuery.s
          }); // 领取失败
        });
    },
    handleClick() {
      // 埋点
      window.sfjsPoint.track('click_immediately_receive', {
        type: this.urlQuery.s
      });

      this.wechatGwechatGetLocation(this.getCoupon);
    },

    viewRule() {
      this.setState({
        ruleFlag: true
      });
    }
  }
};
</script>
<style lang="less">
.page-home {
  .banner {
    position: relative;
    font-size: 0;
    img {
      width: 100%;
    }
    .rule {
      // width: 118px;
      padding: 0 10px;
      height: 52px;
      position: absolute;
      right: 0;
      top: 33px;
      background: rgba(187, 187, 187, 0.6);
      border-radius: 100px 0 0 100px;
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #ffffff;
    }
  }
  .video-bg {
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 30px;
    width: 690px;
    height: 600px;
    position: relative;
    .video-bg-img {
      width: 690px;
      height: 600px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .video-box {
      position: absolute;
      left: 26px;
      top: 143px;
      width: 640px;
      height: 386px;
    }
  }
  .wrapper {
    padding: 0 30px 100px;
    font-size: 0;
    .entry {
      padding: 40px 30px;
      background: #f5f5f5;
      border-radius: 10px;
      text-align: center;
      img {
        width: 100%;
        margin-bottom: 30px;
      }
      .img-wrapper {
        max-height: 316px;
        overflow-y: auto;
      }
      .btn-wrapper {
        position: relative;
        margin: 0 -30px -40px;
        padding: 30px;
        height: 160px;
        background: #ffffff;
        border-radius: 0 0 10px 10px;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          top: -20px;
          height: 20px;
          opacity: 0.21;
          background-image: linear-gradient(0deg, #8e8e8e 0%, rgba(177, 177, 177, 0) 100%);
        }
      }
      .btn {
        flex: 1;
        height: 100px;
        background: #ed2812;
        box-shadow: 0 6px 10px 0 rgba(237, 40, 18, 0.23);
        border-radius: 70px;
        font-family: PingFangSC-Medium;
        font-size: 40px;
        color: #fbeed0;
      }
      .title {
        margin-bottom: 30px;
        font-family: PingFangSC-Semibold;
        font-size: 40px;
        color: #ed2812;
      }
      .fail-img {
        width: 100%;
        // height: 298px;
      }
    }
    .desc-img {
      margin-top: 50px;
      width: 100%;
    }
  }
  .bottom {
    position: fixed;
    height: 160px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff;
    .btn {
      width: 630px;
      height: 100px;
      font-family: PingFangSC-Medium;
      font-size: 36px;
      color: #fbeed0;
      background: #ed2812;
      box-shadow: 0 6px 10px 0 rgba(237, 40, 18, 0.23);
      border-radius: 70px;
    }
    img {
      position: absolute;
      width: 100px;
      height: 100px;
      right: 30px;
      top: -147px;
    }
  }
}
</style>
